import React from 'react'
import {
    StyledPointer,
    StyledPointerImg,
    StyledPointerLink,
    StyledPointerPicture,
} from 'component-library/content/Pointer/Pointer.styled'

export interface Props {
    pointerLinkUrl: string
    pointerImageAlt: string
    pointerImageSrc: string
}

export const Pointer: React.FC<Props> = props => {
    const { pointerImageAlt, pointerImageSrc, pointerLinkUrl } = props

    return (
        <React.Fragment>
            {pointerImageSrc && (
                <StyledPointer>
                    <StyledPointerLink to={pointerLinkUrl}>
                        <StyledPointerPicture>
                            <StyledPointerImg src={pointerImageSrc} alt={pointerImageAlt} />
                        </StyledPointerPicture>
                    </StyledPointerLink>
                </StyledPointer>
            )}
        </React.Fragment>
    )
}

Pointer.displayName = 'Pointer'
